import React, { FC, useCallback, useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { classNames } from '@dt/fe-utils'
import CashierController from 'controllers/cashierController'
import { cartMobx } from 'restaurant'
import Config from 'common/config/config'
import MSDK from 'sdk/monitor'
import './index.scss'
import { getHistoryNew } from '@utils'
import { advertMobx } from '@mobxStore'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list' | 'advert';
interface IProps {
  type?: TProductItem;
  product: IViewProduct;
  ad?: TAdvert;
  style?: any;
  count?: number;
  lazy?: boolean;
  wrapWidth?: number;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
  index: number;
  onClick?: (product: IViewProduct) => void;
}

// 瀑布流图片的宽度
const ProductItem: FC<IProps> = ({ product, count, lazy = false, ad, index, decorate, imgLoaded = false }) => {
  const history = getHistoryNew()
  let { no, name, price, actualPrice, memberPrice, saleCnt, offPrice, isMemberDiscount, isCanTogo, pic } = product || {}
  const ecolor = Config.colorImages[product.categories[0]?.charCodeAt(0) % 4]
  const soldout = saleCnt === 0
  const advertType = 'shopwindow'
  const adType = 'product'
  const adDetail = {
    ...ad,
    pic
  }

  /**
   * 数据采集
   */
  // 点击和曝光上报
  const handleTrace = (eventType) => {
    MSDK.trackClicks({ eventType, ad: adDetail, adType: advertType, page: index })
  }

  useEffect(() => {
    let observerNode
    const target = document.getElementById(`shopwindow_${product.no}_${index}`)
    try {
      observerNode = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // console.log('观察的元素进入了可视范围 ====> shopwindow')
            // do something when the observed element enters the viewport
            // observer.unobserve(entry.target) // 停止观察已经进入可视范围的元素
            try {
              handleTrace('ad_show')
            } catch (error) {
            }
          }
        })
      })
      target && observerNode.observe(target)
    } catch (error) {
    }
    return () => {
      try {
        observerNode.unobserve(target)
      } catch (error) {
      }
    }
  }, [])

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    handleTrace('ad_click')
    advertMobx.pickProductFromAdvert(product.no, adType, adDetail, advertType)
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])

  const [defaultImg, setDefault] = useState<string>('')

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  return (
    <div
      id={`shopwindow_${product.no}_${index}`}
      className={classNames(
        'shopwindow-product-item product-item mini',
        {
          'sold-out': soldout,
        }
      )}
      onClick={() => {
        CashierController.showProductDetail(product)
        advertMobx.pickProductFromAdvert(product.no, adType, adDetail, advertType)
        handleTrace('ad_click')
      }}
    >
      {
        !defaultImg
          ? (
            <div
              className='watercolor' style={{
                backgroundColor: ecolor
              }}
            >
            </div>
          ) : (
            <ProductImage
              color={!defaultImg ? product.no : ''}
              imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
              width={120}
              height={120}
              className='waterfall-img'
            />
          )
      }
      <div className='product-info'>
        <div className='product-name'>{name}</div>
        <div className='product-actions'>
          <Price
            decorate={decorate}
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            hideMarketPrice={!!count}
            soldOut={soldout}
            offPrice={offPrice}
            memberPrice={memberPrice}
            isMemberDiscount={isMemberDiscount}
          />
          {
            soldout ? (
              <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>
            ) : (
              <Stepper cnt={count} size='small' onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !isCanTogo} />
            )
          }
        </div>

      </div>
    </div>
  )
}
export default observer(ProductItem)
